export const ordersData = [
  ...Array.from({ length: 10 }).map((_, index) => {
    const products = [
      {
        name: 'Round Collar Football Jersey',
        size: 'Medium',
        color: ['Red', 'Blue', 'Black'][Math.floor(Math.random() * 3)],
        quantity: Math.ceil(Math.random() * 10),
        price: 12.5,
        amount: Math.floor(Math.random() * 100) + 30,
        status: ['delivered', 'dispatched'][Math.floor(Math.random() * 2)],
        pickupLocation: ['Main Stadium', 'Sports Center', 'Club House'][
          Math.floor(Math.random() * 3)
        ],
      },
      {
        name: 'Goalkeeper Shorts',
        size: 'Large',
        color: ['Green', 'Black'][Math.floor(Math.random() * 2)],
        quantity: Math.ceil(Math.random() * 10),
        price: 15,
        amount: Math.floor(Math.random() * 100) + 40,
        status: ['delivered', 'packed', 'cancelled'][
          Math.floor(Math.random() * 3)
        ],
        pickupLocation: ['Training Ground', 'Main Stadium', 'Sports Center'][
          Math.floor(Math.random() * 3)
        ],
      },
    ];

    return {
      orderId: `ORD${5690 + index}`,
      orderDate: new Date(),
      custName: `Customer ${index + 1}`,
      items: products.length,
      amount: Math.floor(Math.random() * 500) + 50,
      status: ['completed', 'inprogress'][Math.floor(Math.random() * 2)],
      products,
    };
  }),
  ...Array.from({ length: 5 }).map((_, index) => {
    const products = [
      {
        name: 'Goalkeeper Shorts',
        size: 'Large',
        color: ['Green', 'Black'][Math.floor(Math.random() * 2)],
        quantity: Math.ceil(Math.random() * 10),
        price: 15,
        amount: Math.floor(Math.random() * 100) + 40,
        status: ['delivered', 'packed', 'cancelled'][
          Math.floor(Math.random() * 3)
        ],
        pickupLocation: ['Club House', 'Training Ground'][
          Math.floor(Math.random() * 2)
        ],
      },
    ];

    return {
      orderId: `ORD${5700 + index}`,
      orderDate: new Date(new Date().setDate(new Date().getDate() - 1)),
      custName: `Customer ${index + 11}`,
      items: products.length,
      amount: Math.floor(Math.random() * 300) + 100,
      status: ['completed', 'cancelled', 'inprogress'][
        Math.floor(Math.random() * 3)
      ],
      products,
    };
  }),
  ...Array.from({ length: 5 }).map((_, index) => {
    const products = [
      {
        name: 'XPF-AR All-Rounder Cricket Spike',
        size: '11',
        color: ['Blue', 'Red'][Math.floor(Math.random() * 2)],
        quantity: Math.ceil(Math.random() * 5),
        price: 35,
        amount: Math.floor(Math.random() * 100) + 50,
        status: ['cancelled', 'dispatched', 'delivered'][
          Math.floor(Math.random() * 3)
        ],
        pickupLocation: ['Cricket Pavilion', 'Main Stadium', 'Sports Center'][
          Math.floor(Math.random() * 3)
        ],
      },
    ];

    return {
      orderId: `ORD${5710 + index}`,
      orderDate: new Date(
        new Date().setDate(
          new Date().getDate() - Math.floor(Math.random() * 20)
        )
      ),
      custName: `Customer ${index + 16}`,
      items: products.length,
      amount: Math.floor(Math.random() * 300) + 50,
      status: ['completed', 'inprogress', 'cancelled'][
        Math.floor(Math.random() * 3)
      ],
      products,
    };
  }),
  {
    orderId: 'ORD5678',
    orderDate: new Date('2024-06-01'),
    custName: 'John Doe',
    items: 3,
    amount: 150,
    status: 'completed',
    products: [
      {
        name: 'Collar Neck Full Sleeves Jersey',
        size: 'Small',
        color: 'Red',
        quantity: 4,
        price: 6.25,
        amount: 25,
        status: 'delivered',
        pickupLocation: 'Main Stadium',
      },
      {
        name: 'Round Collar Football Jersey',
        size: 'Large',
        color: 'Black',
        quantity: 6,
        price: 12.5,
        amount: 75,
        status: 'delivered',
        pickupLocation: 'Training Ground',
      },
      {
        name: 'XPF-AR All-Rounder Cricket Spike',
        size: '11',
        color: 'Blue',
        quantity: 1,
        price: 35,
        amount: 35,
        status: 'delivered',
        pickupLocation: 'Cricket Pavilion',
      },
    ],
  },
];

export const countryArray = [
  {
    label: 'North America',
    value: 'NA',
    items: [
      {
        label: 'United States',
        code: 'US',
        currency: { label: 'US Dollar', code: 'USD' },
      },
      {
        label: 'Canada',
        code: 'CA',
        currency: { label: 'Canadian Dollar', code: 'CAD' },
      },
      {
        label: 'Mexico',
        code: 'MX',
        currency: { label: 'Mexican Peso', code: 'MXN' },
      },
    ],
  },
  {
    label: 'Europe',
    value: 'EU',
    items: [
      {
        label: 'United Kingdom',
        code: 'GB',
        currency: { label: 'British Pound', code: 'GBP' },
      },
      {
        label: 'Germany',
        code: 'DE',
        currency: { label: 'Euro', code: 'EUR' },
      },
      { label: 'France', code: 'FR', currency: { label: 'Euro', code: 'EUR' } },
      { label: 'Spain', code: 'ES', currency: { label: 'Euro', code: 'EUR' } },
      { label: 'Italy', code: 'IT', currency: { label: 'Euro', code: 'EUR' } },
      {
        label: 'Netherlands',
        code: 'NL',
        currency: { label: 'Euro', code: 'EUR' },
      },
      {
        label: 'Sweden',
        code: 'SE',
        currency: { label: 'Swedish Krona', code: 'SEK' },
      },
      {
        label: 'Norway',
        code: 'NO',
        currency: { label: 'Norwegian Krone', code: 'NOK' },
      },
      {
        label: 'Switzerland',
        code: 'CH',
        currency: { label: 'Swiss Franc', code: 'CHF' },
      },
    ],
  },
  {
    label: 'Asia',
    value: 'AS',
    items: [
      {
        label: 'India',
        code: 'IN',
        currency: { label: 'Indian Rupee', code: 'INR' },
      },
      {
        label: 'Singapore',
        code: 'SG',
        currency: { label: 'Singapore Dollar', code: 'SGD' },
      },
      {
        label: 'China',
        code: 'CN',
        currency: { label: 'Chinese Yuan', code: 'CNY' },
      },
      {
        label: 'South Korea',
        code: 'KR',
        currency: { label: 'South Korean Won', code: 'KRW' },
      },
      {
        label: 'Japan',
        code: 'JP',
        currency: { label: 'Japanese Yen', code: 'JPY' },
      },
      {
        label: 'Hong Kong',
        code: 'HK',
        currency: { label: 'Hong Kong Dollar', code: 'HKD' },
      },
    ],
  },
  {
    label: 'Oceania',
    value: 'OC',
    items: [
      {
        label: 'Australia',
        code: 'AU',
        currency: { label: 'Australian Dollar', code: 'AUD' },
      },
      {
        label: 'New Zealand',
        code: 'NZ',
        currency: { label: 'New Zealand Dollar', code: 'NZD' },
      },
    ],
  },
];
